import React from 'react';
import './DownloadConfirmPopup.css';

const DownloadConfirmPopup = ({ isOpen, onClose, onConfirm, fileCount, groupName }) => {
  if (!isOpen) return null;

  return (
    <div className="download-popup-overlay" onClick={onClose}>
      <div className="download-popup" onClick={(e) => e.stopPropagation()}>
        <div className="download-popup-header">
          <h3>Confirm Download</h3>
          <button className="download-popup-close" onClick={onClose}>×</button>
        </div>
        
        <div className="download-popup-content">
          <p>
            Are you sure you want to download {fileCount} {fileCount === 1 ? 'file' : 'files'}
            {groupName && ` from ${groupName}`}?
          </p>
          <p className="download-popup-warning">
            This will download all files to your device.
          </p>
        </div>
        
        <div className="download-popup-footer">
          <button className="download-popup-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="download-popup-confirm" onClick={onConfirm}>
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadConfirmPopup;
